import Vue from "vue"
import VueI18n from "vue-i18n"
import store from "@/store/"
import PersonalInformationController from "@/features/settings/controllers/personal-information-controller"
import AuthenticationAccounts from "@/features/settings/controllers/authentication-accounts"
import CancelSubscription from "@/features/settings/components/cancel-subscription"
import BillingPortalCancel from "@/features/settings/components/billing-portal-cancel"
import DeleteAccount from "@/features/settings/components/delete-account/section"
import TeamsSettingsController from "@/features/settings/controllers/teams-settings-controller"
import MupOwnerManagementController from "@/features/settings/controllers/mup-owner-management-controller"
import getLocale from "@/utils/locale"

Vue.use(VueI18n)

const initAccountsSection = () => {
  const el = document.getElementById("settings-auth-accounts")
  if (!el) return

  const accounts = JSON.parse(el.dataset.accounts)
  const emails = JSON.parse(el.dataset.emails)
  const hasTempPassword = JSON.parse(el.dataset.hasTempPassword)

  new Vue({
    name: "AuthenticationAccountsInit",
    el,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render(h) {
      return h(AuthenticationAccounts, { props: { accounts, emails, hasTempPassword } })
    }
  })
}

const initTeamsSettings = () => {
  const el = document.getElementById("vue-teams-settings")
  if (!el) return

  new Vue({
    name: "TeamsSettingsInit",
    el,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) => h(TeamsSettingsController)
  })
}

const initMupOwnerManagement = () => {
  const el = document.getElementById("vue-mup-owner-management")
  if (!el) return

  new Vue({
    name: "MupOwnerManagement",
    el,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) => h(MupOwnerManagementController)
  })
}

const initPersonalInformation = () => {
  const el = document.getElementById("personal-information")
  if (!el) return

  new Vue({
    name: "PersonalInformation",
    el,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) => h(PersonalInformationController)
  })
}

const initCancelSubscription = () => {
  const el = document.getElementById("vue-cancel-subscription")
  if (!el) return

  const { isTrialing, subscriptions, membershipMonths, trialChargeDate } = el.dataset || {}

  new Vue({
    name: "CancelSubscriptionInit",
    el,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) =>
      h(CancelSubscription, {
        props: {
          isTrialing: isTrialing === "true",
          membershipMonths: parseInt(membershipMonths, 10) || 0,
          trialChargeDate: trialChargeDate || "",
          subscriptions: JSON.parse(subscriptions)
        }
      })
  })
}

const initBillingPortalCancel = () => {
  const el = document.getElementById("vue-billing-portal-cancel")
  if (!el) return

  const { portalUrl, membershipMonths, isTrialing, trialChargeDate } = el.dataset || {}

  new Vue({
    name: "BillingPortalCancelInit",
    el,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) =>
      h(BillingPortalCancel, {
        props: {
          portalUrl,
          membershipMonths: parseInt(membershipMonths, 10) || 0,
          isTrialing: isTrialing === "true",
          trialChargeDate: trialChargeDate || ""
        }
      })
  })
}

const initDeleteAccount = () => {
  const el = document.getElementById("vue-delete-account")
  if (!el) return

  const { hasPassword } = JSON.parse(el.dataset.config)

  store.commit("settings/hasPasswordDeleteAccount", hasPassword)

  new Vue({
    name: "DeleteAccountInit",
    el,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render: (h) => h(DeleteAccount)
  })
}

const init = () => {
  initAccountsSection()
  initTeamsSettings()
  initMupOwnerManagement()
  initCancelSubscription()
  initBillingPortalCancel()
  initDeleteAccount()
  initPersonalInformation()
}

init()
